import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Pipe({
  name: 'eventoDay'
})
export class EventoDayPipe implements PipeTransform {

  constructor(private language: LanguageService) { }

  transform(value: any, args?: any): any {
    return this.language.formatWeekday(new Date(value));
  }

}
